import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '@/views/HomePage.vue'
import AboutUsPage from '@/views/AboutUsPage.vue'
import ContactPage from '@/views/ContactPage.vue'
import FactoryPage from '@/views/FactoryPage.vue'
import OurProductPage from '@/views/OurProductPage.vue'
import OurServicesPage from '@/views/OurServicesPage.vue'
import SpareParts from '@/views/SpareParts.vue'
import Page404 from '@/views/Page404.vue'
import ProjectReference from '@/views/ProjectReference.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/about',
    name: 'AboutUsPage',
    component: AboutUsPage
  },
  {
    path: '/contact',
    name: 'ContactPage',
    component: ContactPage
  },
  {
    path: '/factory',
    name: 'FactoryPage',
    component: FactoryPage
  },
  {
    path: '/products',
    name: 'OurProductPage',
    component: OurProductPage
  },
  {
    path: '/services',
    name: 'OurServicesPage',
    component: OurServicesPage
  },
  {
    path: '/spare-parts',
    name: 'SpareParts',
    component: SpareParts
  },
  {
    path: '/project-reference',
    name: 'ProjectReference',
    component: ProjectReference
  },
  {
    path: '*',
    name: 'Page404',
    component: Page404
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router